import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import InternalCalculator from '@/components/InternalCalculator';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminCalculatorPage() {
  const token = localStorage.getItem('ratnatraya_token');
  const [searchParams] = useSearchParams();
  const recalcLeadId = searchParams.get('recalc_lead');
  const [recalcLead, setRecalcLead] = useState(null);

  useEffect(() => {
    if (!recalcLeadId || !token) return;
    async function fetchLead() {
      try {
        const res = await fetch(`${API_URL}/api/ccfs-leads?include_test=true`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) {
          const leads = await res.json();
          const lead = leads.find(l => l.id === recalcLeadId);
          if (lead) setRecalcLead({ id: lead.id, lead_number: lead.lead_number, company_name: lead.company_name, cin: lead.cin });
        }
      } catch { /* silently fail */ }
    }
    fetchLead();
  }, [recalcLeadId, token]);

  return (
    <div className="space-y-4" data-testid="admin-calculator-page">
      <div>
        <h1 className="text-xl font-bold text-slate-800">CCFS Calculator</h1>
        <p className="text-sm text-slate-500">Create and manage CCFS penalty worksheets for companies</p>
      </div>
      <InternalCalculator token={token} recalcLead={recalcLead} isAdmin={true} />
    </div>
  );
}
